import React from 'react';
import { MdOutlineExtension } from 'react-icons/md';

import { Box, Card, Flex, Grid, Tag, Text } from 'core/components';
import AddOnCardExtensions, { ExtensionsText } from './AddOnCardExtensions';

type AddOnCardProps = {
  title: string;
  description: string;
  extensions?: ExtensionsText[];
};

const AddOnCard = ({ title, description, extensions = [] }: AddOnCardProps) => (
  <Card p={2} bg="#F3F3F3" borderRadius={8}>
    <Grid gridTemplateColumns="repeat(3, 1fr)" gridTemplateRows="1fr">
      <Box>
        <Flex>
          <Flex flexDirection="column" mr={3} justifyContent="center" alignItems="center">
            <MdOutlineExtension size={20} color="#2D71D1" />
          </Flex>
          <Flex flexDirection="column">
            <Box mb={1}>
              <Text as="span" color="#5F6B7C" fontWeight={500}>
                {title}
              </Text>
              {/* @ts-expect-error to bypass TS errors for the JS <Tag> component until TODO to convert <Tag> component is complete */}
              <Tag ml={1} bg="#E7E9EB" color="#5F6B7C !important" fontSize={12} p="2px 6px" borderRadius={4}>
                Add-On
              </Tag>
            </Box>
            <Text as="div" fontSize={18} fontWeight="bold">
              {description}
            </Text>
          </Flex>
        </Flex>
      </Box>
      {/* Emtpy Box to keep 3-col layout consistent with other LicensePage card layouts */}
      <Box>
        <></>
      </Box>
      <Box>
        <Text as="div" mb={1}>
          Extensions
        </Text>
        <AddOnCardExtensions extensions={extensions} />
      </Box>
    </Grid>
  </Card>
);

export default AddOnCard;
